import { fetch } from '@maxtropy/components';
export const pvCabinetKeys = {
  list: (filters: CabinetQuery) => ['cabinets', 'list', { filters }],
};

export enum PVCabinetType {
  SVG,
  GRID_TIE_OUTGOING_CABINET,
  PV_INCOMING_CABINET,
  TRANSFORMER,
  STATION_ELECTRIC_METER,
}

export namespace PVCabinetType {
  export const MAP = {
    [PVCabinetType.SVG]: 'SVG',
    [PVCabinetType.GRID_TIE_OUTGOING_CABINET]: '并网出线柜',
    [PVCabinetType.PV_INCOMING_CABINET]: '光伏进线柜',
    [PVCabinetType.TRANSFORMER]: '变压器',
    [PVCabinetType.STATION_ELECTRIC_METER]: '站用电电表',
  };
}

export interface PVCabinet {
  id: number;
  code: string;
  deviceCode: string;
  deviceId: number;
  deviceName: string;
  gridConnectionPointId: number;
  gridConnectionPointName: string;
}

export interface CabinetPayload {
  id?: number;
  name: string;
  deviceId?: number;
  gridConnectionPointId: number;
  pvId: number;
  type: PVCabinetType;
}

export interface CabinetQuery {
  pvId: number;
}

export const getCabinetList = (params: CabinetQuery) =>
  fetch<{ list: PVCabinet[] }>(
    `/api/v2/pv-high-voltage-cabinet/list`,
    {
      method: 'POST',
      body: JSON.stringify({ id: params.pvId }),
    },
    true
  ).then(res => res.list ?? []);

export const createCabinet = (data: CabinetPayload) =>
  fetch<void>(`/api/v2/pv-high-voltage-cabinet/create`, { method: 'POST', body: JSON.stringify(data) }, true);

export const updateCabinet = (data: CabinetPayload) =>
  fetch<void>(`/api/v2/pv-high-voltage-cabinet/update`, { method: 'POST', body: JSON.stringify(data) }, true);

export const deleteCabinet = (id: number) =>
  fetch<void>(`/api/v2/pv-high-voltage-cabinet/delete`, { method: 'POST', body: JSON.stringify({ id }) }, true);

export const deleteAllCabinets = (id: number) =>
  fetch<void>(`/api/v2/pv-high-voltage-cabinet/delete-all`, { method: 'POST', body: JSON.stringify({ id }) }, true);

export const removeCabinetDevice = (id: number) =>
  fetch<void>(`/api/v2/pv-high-voltage-cabinet/remove-device`, { method: 'POST', body: JSON.stringify({ id }) }, true);

export const updateCabinetDevice = (id: number, deviceId: number) =>
  fetch<void>(
    `/api/v2/pv-high-voltage-cabinet/update-device`,
    { method: 'POST', body: JSON.stringify({ id, deviceId }) },
    true
  );
